import { render, staticRenderFns } from "./mother_current_info.vue?vue&type=template&id=3ebff117&scoped=true&"
import script from "./mother_current_info.vue?vue&type=script&lang=js&"
export * from "./mother_current_info.vue?vue&type=script&lang=js&"
import style0 from "./mother_current_info.vue?vue&type=style&index=0&id=3ebff117&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebff117",
  null
  
)

export default component.exports